import { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  ListItem,
  Typography,
} from "@mui/material";
import { STATUS_SENTENCES } from "../../utils/constants/StatusType.constants";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function DosenUserManual() {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  return (
    <div className="mt-2">
      <div className="py-3">
        <div>
          <span className="font-bold">Dosen:</span>{" "}
          <a
            href={require("../../assets/user_manuals/User_Manual_Dosen_v1.0.0.pdf")}
            download={"User_Manual_Dosen_v1.0.0.pdf"}
            className="text-blue-500 hover:underline"
          >
            User_Manual_Dosen_v1.0.0.pdf
          </a>
        </div>
        <div>
          <span className="font-bold">Mahasiswa:</span>{" "}
          <a
            href={require("../../assets/user_manuals/User_Manual_Mahasiswa_v1.0.0.pdf")}
            download={"User_Manual_Mahasiswa_v1.0.0.pdf"}
            className="text-blue-500 hover:underline"
          >
            User_Manual_Mahasiswa_v1.0.0.pdf
          </a>
        </div>
      </div>

      <h2 className="mt-7 font-bold mb-4">Petunjuk Beranda Dosen</h2>
      <Accordion
        expanded={expanded === "butuhTindakan"}
        onChange={handleChange("butuhTindakan")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="butuhTindakan-content"
          id="butuhTindakan-header"
        >
          <Typography sx={{ width: "33%", flexShrink: 0, fontWeight: "bold" }}>
            Butuh Tindakan
          </Typography>
          <Typography sx={{ color: "text.secondary" }}>
            Membutuhkan tindakan dari pengguna (saya)
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Status yang tergolong butuh tindakan, di antaranya:
          </Typography>
          <Typography>
            <ListItem sx={{ display: "list-item", py: 0 }}>
              {STATUS_SENTENCES["Menunggu persetujuan maju sidang"]} (khusus
              dosen pembimbing)
            </ListItem>
            <ListItem sx={{ display: "list-item", py: 0 }}>
              {STATUS_SENTENCES["Menunggu penilaian dan/atau revisi"]}
            </ListItem>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "menungguTindakan"}
        onChange={handleChange("menungguTindakan")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="menungguTindakan-content"
          id="menungguTindakan-header"
        >
          <Typography sx={{ width: "33%", flexShrink: 0, fontWeight: "bold" }}>
            Menunggu Tindakan Pihak Lain
          </Typography>
          <Typography sx={{ color: "text.secondary" }}>
            Menunggu tindakan dari pengguna lain
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Status yang tergolong menunggu pihak lain, di antaranya:
          </Typography>
          <Typography>
            <ListItem sx={{ display: "list-item", py: 0 }}>
              {STATUS_SENTENCES["Menunggu kode etik dan/atau berkas"]} dari
              mahasiswa
            </ListItem>
            <ListItem sx={{ display: "list-item", py: 0 }}>
              {STATUS_SENTENCES["Menunggu peer review"]} dari mahasiswa
            </ListItem>
            <ListItem sx={{ display: "list-item", py: 0 }}>
              {STATUS_SENTENCES["Menunggu penjadwalan sidang"]} dari sekretariat
            </ListItem>
            <ListItem sx={{ display: "list-item", py: 0 }}>
              {STATUS_SENTENCES["Menunggu sidang"]}
            </ListItem>
            <ListItem sx={{ display: "list-item", py: 0 }}>
              {STATUS_SENTENCES["Menunggu penilaian dan/atau revisi"]} dari
              dosen lain
            </ListItem>
            <ListItem sx={{ display: "list-item", py: 0 }}>
              {STATUS_SENTENCES["Menunggu berkas akhir"]} dari mahasiswa
            </ListItem>
          </Typography>
          <Typography sx={{ pt: 2 }}>
            Terkhusus status "{STATUS_SENTENCES["Menunggu penjadwalan sidang"]}
            ", aksi pada detail panel beranda masih menyediakan "Batalkan Maju
            Sidang" sebagai fitur membatalkan persetujuan maju sidang. Sedangkan
            pada status "
            {STATUS_SENTENCES["Menunggu penilaian dan/atau revisi"]} dari dosen
            lain", masih tersedia aksi "Nilai" atau "Revisi" sebagai fitur
            ubah/lihat nilai atau revisi Mata Kuliah Spesial tersebut.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "selesai"}
        onChange={handleChange("selesai")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="selesai-content"
          id="selesai-header"
        >
          <Typography sx={{ width: "33%", flexShrink: 0, fontWeight: "bold" }}>
            Selesai
          </Typography>
          <Typography sx={{ color: "text.secondary" }}>
            Mata Kuliah Spesial yang telah selesai
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Sebagaimana namanya, status yang tergolong selesai hanyalah
            "Selesai".
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
